import { createOidcUserManager } from './config'

export async function oidcSignInRedirect(): Promise<void> {
  const userManager = createOidcUserManager()
  await userManager.signinRedirect()
}
